// extracted by mini-css-extract-plugin
export default {"removeIcon":"TeamPicker_removeIcon__BBxbu"};